export default "__VITE_ASSET__DSjzZ1rS__"